
<p-panel>
    @if (flag === 'edit' && env.appName === 'ebro') {
        <div class="alert alert-info p-2 small">
            <b><i class="fa fa-exclamation-circle"></i> Atención:</b>
            La sincronización con el sistema Sage sobreescribirá toda la
            información editada aquí, excepto el campo <code>observaciones</code>.
        </div>

    }

   <div class="row">
        <app-reactive-form-builder
                #formbuilder
                [id]="reactiveFormRecordId"
                (stableValueChanges)="stableValueChanges($event)"
                (goBack)="handleReactiveSubmitGoBack()"
                (afterSend)="undefined"
                [form]="form.formFields"
                [serverUrl]="''"
                [request]="request"
                [getRequest]="clientesApi.clienteByIdGET">
        </app-reactive-form-builder>
    </div>
</p-panel>
<br>
